module.exports = __webpack_public_path__ + "5e7fb04cf7810bd30e07e06eb0ce2731.svg";